import React from "react";
import "../assets/styles/Menu_select.css";
import { Link } from "react-router-dom";

const Menu_select = ({ menuItems }) => {

  return (
    <div className="Menu-select-box">
      <ul>
        <li className="menu-header">
          <Link to="#">Sports</Link>
        </li>
        {menuItems && menuItems?.length > 0 ? (
          menuItems.map((item, index) => (
            <li
              key={index}
              className={item?.isHeader ? "menu-header" : "menu-item"}
            >
              <Link to={`?${item?.eventName}`}>{item?.eventName}</Link>
            </li>
          ))
        ) : (
          <>
            <li className="menu-item">
              <Link to="/cricekt">Cricekt</Link>
            </li>
            <li className="menu-item">
              <Link to="/soccer">Soccer</Link>
            </li>
            <li className="menu-item">
              <Link to="/tennis">Tennis</Link>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default Menu_select;
